import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("vastrakiran_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data.user);
        setTenant(r.data.tenant);
      })
      .catch(() => {
        localStorage.removeItem("vastrakiran_token");
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("vastrakiran_token", data.token);
    setUser(data.user);
    setTenant(data.tenant);
    return data;
  };

  const registerTenant = async (payload) => {
    const { data } = await api.post("/auth/register-tenant", payload);
    return data;
  };

  const resendVerification = async (email) => {
    const { data } = await api.post("/auth/resend-verification", { email });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("vastrakiran_token");
    setUser(null);
    setTenant(null);
  };

  return (
    <AuthCtx.Provider value={{ user, tenant, loading, login, registerTenant, resendVerification, logout, setTenant }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
